'use client'

import { useEffect } from 'react'

import { usePathname, useSearchParams } from '@/shared/lib/router'
import NProgress from 'nprogress'

import 'nprogress/nprogress.css'

function isInternalLink(target: EventTarget | null): target is HTMLAnchorElement {
  if (!target || !(target instanceof HTMLAnchorElement)) return false
  const href = target.getAttribute('href')
  if (!href || href.startsWith('#') || target.target === '_blank') return false
  if (href.startsWith('mailto:') || href.startsWith('tel:')) return false
  return href.startsWith('/') || new URL(href, window.location.origin).origin === window.location.origin
}

export function NavigationProgress() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    NProgress.configure({ showSpinner: false })
  }, [])

  useEffect(() => {
    NProgress.done()
  }, [pathname, searchParams])

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (isInternalLink(e.target)) NProgress.start()
    }
    document.addEventListener('click', handleClick, true)
    return () => document.removeEventListener('click', handleClick, true)
  }, [])

  return null
}
